import { injectable } from 'inversify';
import 'reflect-metadata';

import { IBagApi } from '@@/bags/ts';
import { CrudService, ICrudService } from '@@/common/services/crud.service';
import { CrudMeta } from '@@/common/decorators/crud-meta.decorator';
import { get } from '@/shared/api/api-client';

@injectable()
@CrudMeta({
  modelName: 'bag',
  tableName: 'bag',
})
export class BagsService extends CrudService<IBagApi> implements IBagsService {
  async getWheatClass({
    wheat_type,
    protein,
    gluten,
    idk,
    hfn,
    density,
    temperature = '23',
    moisture,
    weed,
  }: {
    wheat_type: string;
    protein: string;
    gluten: string;
    idk: string;
    hfn: string;
    density: string;
    temperature?: string;
    moisture: string;
    weed?: string;
  }): Promise<{ wheat_class: number }> {
    const res: any = await get(`${PUBLIC_RUSTMIX_URL}/class`, {
      wheat_type,
      protein,
      gluten,
      idk,
      hfn,
      density,
      temperature,
      moisture,
      // weed,
    });
    return res;
  }

  async getClassParams(clsNumber: number, wheat_type: number, mock?: boolean) {
    try {
      if (mock) {
        const randomNumber = Math.floor(Math.random() * 6);
        const result = new Promise(() => setTimeout(() => randomNumber, 500));
        return await result;
      }
      const res = await get(`${PUBLIC_RUSTMIX_URL}/class`, {
        wheat_type,
        wheat_class: clsNumber,
      });
      return res;
    } catch {
      return null;
    }
  }
}

export interface IBagsService extends ICrudService<IBagApi> {}
